import { render } from "./SearchConditionPopupNumResults.vue?vue&type=template&id=65dd0910&scoped=true&ts=true"
import script from "./SearchConditionPopupNumResults.vue?vue&type=script&lang=ts"
export * from "./SearchConditionPopupNumResults.vue?vue&type=script&lang=ts"

import "./SearchConditionPopupNumResults.vue?vue&type=style&index=0&id=65dd0910&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dd0910"]])

export default __exports__